module.exports = __webpack_public_path__ + "assets/icons/junk-active.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/jobcategories/junk-active.png
// module id = ./src/styles/icons/jobcategories/junk-active.png
// module chunks = 0